customElements.define(

    "cc-section-header", 

    class extends HTMLElement{

      connectedCallback(){

        const label = this.textContent;

        this.innerHTML = `

          <h3 id="cc-section-header">${label}</h3>

        `;

      }
          
    }

);